export default "__VITE_ASSET__BHbm_cti__"